(() => {
  'use strict';

  // Shopify can evaluate this asset again while replacing a section.
  if (document.documentElement.dataset.atProductRelatedReady === 'true') return;
  document.documentElement.dataset.atProductRelatedReady = 'true';

  const sections = new Map();
  const selector = '[data-related-materials]';
  const reducedMotion = typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function mount(root) {
    if (sections.has(root)) return;
    const track = root.querySelector('[data-related-track]');
    const controls = root.querySelector('[data-related-controls]');
    const previous = controls?.querySelector('[data-related-prev]');
    const next = controls?.querySelector('[data-related-next]');
    if (!track || !controls || !previous || !next) return;

    let frame = null;
    let active = true;

    function update() {
      frame = null;
      if (!active) return;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.max(0, Math.min(maximum, track.scrollLeft));
      const overflows = track.clientWidth > 0 && maximum > 1;
      controls.hidden = !overflows;
      previous.disabled = !overflows || position <= 1;
      next.disabled = !overflows || position >= maximum - 1;
    }

    function schedule() {
      if (!active || frame !== null) return;
      if (typeof window.requestAnimationFrame !== 'function') update();
      else frame = window.requestAnimationFrame(update);
    }

    function move(direction) {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.max(0, Math.min(maximum, track.scrollLeft));
      const target = Math.max(0, Math.min(maximum, position + direction * track.clientWidth * 0.9));
      if (target === position) return;
      track.scrollBy({ left: target - position, behavior: reducedMotion?.matches ? 'auto' : 'smooth' });
    }

    const goPrevious = () => move(-1);
    const goNext = () => move(1);
    previous.addEventListener('click', goPrevious);
    next.addEventListener('click', goNext);
    track.addEventListener('scroll', schedule, { passive: true });

    const observer = typeof window.ResizeObserver === 'function'
      ? new window.ResizeObserver(schedule)
      : null;
    if (observer) {
      observer.observe(track);
      // Card widths can change independently of the viewport as fonts and images load.
      Array.from(track.children).forEach((card) => observer.observe(card));
    } else window.addEventListener('resize', schedule, { passive: true });

    sections.set(root, () => {
      active = false;
      if (frame !== null && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(frame);
      frame = null;
      observer?.disconnect();
      window.removeEventListener('resize', schedule);
      track.removeEventListener('scroll', schedule);
      previous.removeEventListener('click', goPrevious);
      next.removeEventListener('click', goNext);
      controls.hidden = true;
      previous.disabled = true;
      next.disabled = true;
    });
    update();
  }

  function init(scope = document) {
    if (scope.matches?.(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    sections.forEach((cleanup, root) => {
      if (event.target === root || event.target.contains(root)) {
        cleanup();
        sections.delete(root);
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
